import consts from '@/common/const'
import { CacheUtil } from '@/common/cacheUtil'
import {sysUtil} from "jscom/utils/sysutil"

export function splitPriceStr (priceStr) {
  let arr = priceStr.split('.')
  let intPrice = arr[0]
  let intPriceArr = []
  let startLen = intPrice.length % 3
  if (startLen === 0) {
    startLen = 3
  }
  intPriceArr.push(intPrice.substr(0, startLen))
  for (; startLen < intPrice.length; startLen += 3) {
    intPriceArr.push(intPrice.substr(startLen, 3))
  }
  let result = intPriceArr.join(',')
  if (arr.length > 1) {
    result += '.' + arr[1]
  }
  return result
}

// format price
export function formatPrice (price) {
  let priceStr = `${price / 100}`
  return '￥' + splitPriceStr(priceStr)
}

// 积分
export function formatPoints (points) {
  return `${points}积分`
}

// format bill price
export function formatBillPrice (price) {
  let priceStr = `${price / 100}`
  return splitPriceStr(priceStr) + '元'
}

// get spuid from skuid
export function getSpuid (skuid) {
  return Math.floor(skuid / 1000)
}

// go back
export function goBack (router) {
  if (window.history.length > 1) {
    router.go(-1)
  } else {
    router.push('/home')
  }
}

// check login and goto login
export function checkLoginAndGoto (store, router, fullpath) {
  if (!store.getters.isLogin) {
    let routePath = {}
    routePath.path = '/login'
    if (fullpath) {
      routePath.query = {redirect: fullpath}
    }
    router.push(routePath)
    return false
  }
  return true
}

// get cart sku by skuid
export function getCartskuByid (cartList, skuid) {
  return cartList.find(function (value, index, arr) {
    return value.skuid === skuid
  })
}

// get cart sku index by skuid
export function getCartskuIndexByid (cartList, skuid) {
  return cartList.findIndex(function (value, index, arr) {
    return value.skuid === skuid
  })
}

/*
  @param info '110000-上海'
  @return {code: 110000, name: '上海'}
*/
export function splitDistrictInfo (info) {
  if (!info) {
    return {code: 0, name: ''}
  }
  let infoArr = info.split('-')
  if (infoArr.length !== 2) {
    return {code: 0, name: info}
  }
  let retValue = {}
  retValue.code = Number(infoArr[0])
  retValue.name = infoArr[1]
  return retValue
}

/*
  @param value {code: 110000, name: '上海'}
  @return '110000-上海'
*/
export function mergeDistrictInfo (value) {
  return `${value.code}-${value.name}`
}

// check mobile number
export function rightMobileNumber (mobile) {
  return /^1\d{10}$/gi.test(mobile)
}

// get full address by addressInfo
export function getFullAddress (addressInfo) {
  let fullAddress = ''
  fullAddress += splitDistrictInfo(addressInfo.province).name
  fullAddress += ' '
  fullAddress += splitDistrictInfo(addressInfo.city).name
  fullAddress += ' '
  fullAddress += splitDistrictInfo(addressInfo.district).name
  fullAddress += ' '
  fullAddress += addressInfo.address
  return fullAddress
}

/*
  @param [time: int]: '800'
  @return {hour: 8, minute: 0}
*/
export function getHourMinute (time) {
  let value = {}
  value.hour = Math.floor(time / 100)
  value.minute = time % 100
  return value
}

/*
  @param [time: string]: '08:00'
  @return '上午08点00分'
*/
export function formatTime (time) {
  let value = getHourMinute(time)
  let hour = value.hour
  let start = '上午'
  if (hour > 12) {
    hour -= 12
    start = '下午'
  }
  let padHour = `${hour}`.padStart(2, '0')
  let padMinute = `${value.minute}`.padStart(2, '0')
  return `${start}${padHour}点${padMinute}分`
}

/*
  @param [svrTime: number]: 800
  @return '08:00'
*/
export function getTimeBySvrTime (svrTime) {
  let padHour = `${Math.floor(svrTime / 100)}`.padStart(2, '0')
  let padMinute = `${svrTime % 100}`.padStart(2, '0')
  return `${padHour}:${padMinute}`
}

export function getIntervalTime (interval) {
  let hour = `${Math.floor(interval / 3600)}`.padStart(2, '0')
  let minSecond = interval % 3600
  let min = `${Math.floor(minSecond / 60)}`.padStart(2, '0')
  let second = `${Math.floor(minSecond % 60)}`.padStart(2, '0')
  return `${hour}小时${min}分钟${second}秒`
}

/*
  @param [datetime: object]: {start: 800, end: 1200}
  @return '08:00 - 12:00'
*/
export function formatDeliveryDatetime (datetime) {
  if (datetime.start === 800 && datetime.end === 1800) {
    return '不限'
  }
  return getTimeBySvrTime(datetime.start) + ' - ' + getTimeBySvrTime(datetime.end)
}

/*
  @param [src: string]
         [pos: number] start position
         [rText: string] replace text
  @return modify string
*/
export function replaceChar (src, pos, rText) {
  let result = src.substring(0, pos) + rText + src.substring(pos + rText.length)
  return result
}

export function formatMobile (mobile) {
  if (!mobile) {
    return ''
  }
  return replaceChar(mobile, 3, '****')
}

// format info count, if count > 99 is 99+
export function formatInfoCount (count) {
  if (!count) {
    return null
  }
  return count > 99 ? `99+` : `${count}`
}

/* get url params
   @param [url: string]: http://app.mi2c.com?c=mishe
   @return {c: 'mishe'}
*/
export function getUrlParams (url) {
  let params = {}
  let urls = url.split('?')
  if (urls.length === 1) {
    return params
  }
  let strParam = urls[1].split('#')[0]
  let strParamArray = strParam.split('&')
  for (let paramItem of strParamArray) {
    let param = paramItem.split('=')
    if (param.length === 2) {
      params[decodeURIComponent(param[0])] = decodeURIComponent(param[1])
    }
  }
  return params
}

/*
  @param window.location
*/
export function checkActivateUrl (location) {
  if (location.search &&
    location.search.indexOf('card_id') !== -1 &&
    location.search.indexOf('activate_ticket') !== -1) {
    location.hash = '#activatecard'
  }
}

export function subStr (name) {
  if (name) {
    if (name.length > 3) {
      return name.substring(0, 3) + `...`
    }
    return name
  }
  return ''
}

/*
*/
export function redirectMainUrl (to, from, next, isLogin, uweb) {
  let nextPath = ''
  if (to.path === '/wxcard_promotion' ||
    to.path === '/wxmp_menu_enterbuy' ||
    to.path === '/alipay_menu_enterbuy' ||
    to.path === '/xnpkg_enterbuy') {
    uweb.trackPageview(to.fullPath, '')
    // if (isLogin) {
    //   nextPath = '/shortcut'
    // } else {
    //   nextPath = '/login'
    // }
  } else if (to.path === '/login' && isLogin && !CacheUtil.getToken()) {
    nextPath = '/shortcut'
  }

  if (nextPath) {
    next({
      path: nextPath
    })
    return true
  }
  return false
}

export function redirectTokenUrl() {
  let params = getUrlParams(window.location.href)
  if (params.token) {
    CacheUtil.setToken(params.token)
    let hash = ''
    if (window.location.hash) {
      let slist = window.location.hash.split('?')[0].split('#')
      hash = slist[slist.length-1]
    }
    let paramStrList = ['redirect='+hash]
    let sellerCompanyid = 0
    for (let [key, val] of Object.entries(params)) {
      if (key === 'token') continue
      if (key === 'sellerCompanyid') {
        sellerCompanyid = val
        continue
      }
      paramStrList.push(`${key}=${val}`)
    }
    let paramstr = paramStrList.join('&')
    if (paramstr) paramstr = '?'+paramstr
    let url = `${window.location.protocol}//${window.location.host}${window.location.pathname}`
    if (sellerCompanyid) {
      url = `${url}?sellerCompanyid=${sellerCompanyid}`
    }
    url = `${url}#/login${paramstr}`
    window.location.href = url
  }
}

/*
  @param [cardNumber: string]: '000000000005'
  @return '0000 0000 0005'
*/
export function formatCardNumber (cardNumber) {
  let result = ''
  if (!cardNumber) {
    return ''
  }
  let subLength = 4
  let numberLength = cardNumber.length
  for (let index = 0; index < numberLength; index = index + subLength) {
    result += ' ' + cardNumber.substr(index, subLength)
  }
  return result
}

export function getObjectValue (obj, keys, defaultValue) {
  if (!obj || !keys) {
    return defaultValue
  }

  let keyArr = keys.split('.')
  let ret = obj
  for (let key of keyArr) {
    if (!ret[key]) {
      ret = null
      break
    }
    ret = ret[key]
  }

  return ret || defaultValue
}

export function isOnlineHost () {

}

function _stringPad (str, maxLength, fillStr, left) {
  let strLength = str.length
  let fillString = fillStr === undefined ? ' ' : fillStr
  if (strLength >= maxLength || fillStr === '') {
    return str
  }
  let fillLen = maxLength - strLength
  let repeatCount = Math.round(fillLen / fillString.length)
  let strFiller = ''
  for (let n = 0; n < repeatCount; n++) {
    strFiller += fillString
  }
  if (strFiller.length > fillLen) {
    strFiller = strFiller.slice(0, fillLen)
  }
  return left ? strFiller + str : str + strFiller
}

export function padStart (maxLength, fillStr) {
  return _stringPad(this, maxLength, fillStr, true)
}

export function padEnd (maxLength, fillStr) {
  return _stringPad(this, maxLength, fillStr, false)
}

/*
  @param [startTime: timestamp]: 000000000005
         [expires: int]: 3600 单位: 秒
  @return true | false
*/
function _checkTimeout (startTime, expires) {
  let curDate = new Date()
  let interval = curDate.getTime() - startTime
  return interval > (expires * 1000)
}

export function isPayTimeout (createTime) {
  return _checkTimeout(createTime, consts.orderPayTime)
}

export function formatRiceCoin (riceCoin) {
  return `${riceCoin}米粒`
}

export function getOriginPriceStr (sku) {
  if (sku.origPrice > 0 && sku.origPrice !== sku.price) {
    return formatPrice(sku.origPrice)
  }
  return ''
}

const { hasOwnProperty } = Object.prototype

function assignKey (to, from, key) {
  const val = from[key]

  if (!sysUtil.isDefined(val) || (hasOwnProperty.call(to, key) && !sysUtil.isDefined(to[key]))) {
    return
  }

  if (!hasOwnProperty.call(to, key)) {
    if (!sysUtil.isObject(val)) {
      to[key] = val
    } else if (Array.isArray(val)) {
      to[key] = []
      for (let index in val) {
        assignKey(to[key], val, index)
      }
    } else {
      to[key] = deepAssign({}, val)
    }
  } else {
    to[key] = deepAssign(Object(to[key]), from[key])
  }
}

export function deepAssign (to, from) {
  for (const key in from) {
    if (hasOwnProperty.call(from, key)) {
      assignKey(to, from, key)
    }
  }
  return to
}

export function deepClone (obj) {
  if (Array.isArray(obj)) {
    return obj.map(item => deepClone(item))
  } else if (typeof obj === 'object') {
    return deepAssign({}, obj)
  }
  return obj
}

export function formatIdCardNum (number) {
  if (!number || number.length < 18) {
    return number
  }
  return replaceChar(number, 6, '********')
}

export function dialPhone (phoneNumber) {
  let ref = `tel:${phoneNumber}`
  window.location = ref
}

export function selValue (selDistrictArr) {
  if (!selDistrictArr || selDistrictArr.length === 0) {
    return ''
  }
  return selDistrictArr[2].code + ''
}



// WEBPACK FOOTER //
// ./src/common/miscutil.js